
import React, { useState } from "react";
import { Alert, Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row } from "reactstrap";
import DefaultOffCanvas from "../DefaultOffCanvas";
import form from 'formConfigs/resendConfirmation';
import DynamicForm from "components/DynamicForm";
import styles from "./style.module.scss"
import cx from "classnames";
import { resendUserConfirmation } from "utils/Session";
import { showAlert } from "utils/Alert";

const ResendConfirmationOffCanvas = props => {
    const { wrapper, btnColor = "primary", className } = props;
    const [isOpen, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const ButtonWrapper = wrapper || "Button";

    const toogleOffCanvas = (newState) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const resendConfirmation = async (formData) => {
        const result = await resendUserConfirmation(formData.email)
        console.log(result);
        showAlert("sucess", "Confirmacion enviada")
    }

    const getFormConfig = () => {
        return form;
    }

    return (
        <>
            <ButtonWrapper
                color={btnColor}
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </ButtonWrapper>
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Reenvio confirmacion de Cuenta
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert color="warning">Por favor ingrese el correo electronio del usuario para enviar la confirmacion de la cuenta</Alert>
                        <DynamicForm
                            id="userConfirmation"
                            formConfig={getFormConfig()}
                            onSubmit={resendConfirmation}
                            isLoading={isLoading}>
                            <Row>
                                <Col>
                                    <Button
                                        className="float-end"
                                        type="submit"
                                        color="success">
                                        Enviar
                                    </Button>
                                </Col>
                            </Row>
                        </DynamicForm>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default ResendConfirmationOffCanvas;
